import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@material-ui/core';
import SetupCard from './SetupCard';
import RealGrid from '../Layout/RealGrid';
import IntlMessages from 'util/IntlMessages';

const industries = [
  {
    id: 'clothing',
    title: "ui.setupVisualRecs.onboardingIndustry.clothingApparelFashion",
    icon: 'clothing.svg',
  },
  {
    id: 'shoes',
    title: "ui.setupVisualRecs.onboardingIndustry.shoesAccessories",
    icon: 'accessories.svg',
  },
  {
    id: 'interior',
    title: "ui.setupVisualRecs.onboardingIndustry.furnitureArtDesign",
    icon: 'interior.svg',
  },
  {
    id: 'kids',
    title: "ui.setupVisualRecs.onboardingIndustry.kidsClothingAccessoriesToys",
    icon: 'kids.svg',
  },
  {
    id: 'exterior',
    title: "ui.setupVisualRecs.onboardingIndustry.homeGarden",
    icon: 'exterior.svg',
  },
  {
    id: 'other',
    title: "ui.setupVisualRecs.onboardingIndustry.other",
    icon: 'other.svg',
  },
];

export default function OnboardingIndustry({ onClick }) {
  const activeCards = useSelector((store) => store.onboarding.recs.industries);
  const cards = industries.map((industry) => {
    const { id, title, icon } = industry;
    const active = activeCards.indexOf(id) > -1;
    return (
      <SetupCard
        active={active}
        key={id}
        title={title}
        icon={icon}
        onClick={() => onClick(id)}
      />
    );
  });

  const classes = {
    circle_1: {
      boxSizing: 'border-box',
      position: 'absolute',
      width: '1322.59px',
      height: '1320px',
      left: '649px',
      top: '517px',
      background: '#FFFFFF',
      border: '1px solid var(--kea-color-primary-soft)',
      transform: 'rotate(-63.36deg)',
      borderRadius: '50%',
      zIndex: 0,
    },
    circle_2: {
      boxSizing: 'border-box',
      position: 'absolute',
      width: '1322.59px',
      height: '1320px',
      left: '-445.8px',
      top: '78px',
      border: '1px solid var(--kea-color-primary-soft)',
      transform: 'rotate(-63.36deg)',
      borderRadius: '50%',
      zIndex: 1,
    },
    circle_3: {
      boxSizing: 'border-box',
      position: 'absolute',
      width: '1322.59px',
      height: '1320px',
      left: '-415px',
      top: '200px',
      background: '#FFFFFF',
      border: '1px solid var(--kea-color-primary-soft)',
      borderRadius: '50%',
      zIndex: 2,
    },
  };

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '80vh' }}>
      <div style={{
        position: 'static',
        zIndex: -1,
      }}
      >
        <div style={classes.circle_1} />
        <div style={classes.circle_2} />
        <div style={classes.circle_3} />
      </div>

      <Box px={3} py={10}>
        <Typography variant="h4" align="center" gutterBottom>
          <IntlMessages id="ui.setupVisualRecs.onboardingIndustry.pleaseSelectTheIndustryThatBestMatchesYourStoreSProducts" />
        </Typography>
        <Typography variant="body1" align="center" paragraph style={{ marginBottom: 40 }}>
          <IntlMessages id="ui.setupVisualRecs.onboardingIndustry.ourAiModelsWillBeFineTunedToProvideTheBest" />
        </Typography>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <RealGrid>{cards}</RealGrid>
        </Grid>
      </Box>
    </Grid>
  );
}
